app.controller('blogPostController', function ($scope, $routeParams, $window, $location, safeApply, blogService) {

  $scope.route = 'blog'

  initController()
  
  console.log('$routeParams :>> ', $routeParams);

  // $location.path('/blog_post/longURL+HERE_BLOG_AA%2AA', false);
  // $location.path('/blog_post/123/longURL+HERE_BLOG_AA%2AA', false).replace();
  // var decodedUrl = decodeURIComponent('/blog_post/123/https://www.ownwell.com/blog/How-The-Homestead-Cap-Impacts-Texas-Property-Tax-Protests%20-14');
  // console.log(decodedUrl);

  $scope.viewPost = (post) => { 
    $location.path(`/blog_post/${post}`)
  }

  $scope.updateLikes = async (post) => {
    let res = await blogService.updatePostLike({ id: post.id })
    if (res.data.success) {
      post.liked++
      safeApply($scope)
    } 
  }

  async function initController() {
    $scope.menu_background_solid = true

    let post = await blogService.getBlogPost({ id: $routeParams.id })
    $scope.post = {
      ...post.data.data.post,
      related_posts: post.data.data.related_posts,
      recent_posts : post.data.data.recent_posts
    }
    console.log('$scope.post :>> ', $scope.post);
    
    // updateMetaTags($scope.post)

    initComponents()
    safeApply($scope)
    setTimeout(() => {
      tippy('[data-tippy-content]', {
        animation: 'perspective-extreme',
      })
      new ClipboardJS('.clipboard')
    }, 0)
  }

  // function updateMetaTags(post) { 
  //   $scope.meta = {
  //     url        : `https://propertytax.io/blog_post/${post.id}`,
  //     title      : post.title,
  //     description: post.description,
  //     image      : post.image,
  //     card       : post.image
  //   }
  //   safeApply($scope)
  // }

  // *************************************************************************
  // Leave this at the bottom - do not put any functions below this section **
  // *************************************************************************
  function initComponents() {
    feather.replace()

    //Menu
    // Toggle menu
    $scope.toggleMenu = () => {
      document.getElementById('isToggle').classList.toggle('open')
      var isOpen = document.getElementById('navigation')
      if (isOpen.style.display === "block") {
        isOpen.style.display = "none"
      } else {
        isOpen.style.display = "block"
      }
    }

    //Menu Active
    function getClosest(elem, selector) {

      // Element.matches() polyfill
      if (!Element.prototype.matches) {
        Element.prototype.matches =
          Element.prototype.matchesSelector ||
          Element.prototype.mozMatchesSelector ||
          Element.prototype.msMatchesSelector ||
          Element.prototype.oMatchesSelector ||
          Element.prototype.webkitMatchesSelector ||
          function (s) {
            var matches = (this.document || this.ownerDocument).querySelectorAll(s),
              i = matches.length;
            while (--i >= 0 && matches.item(i) !== this) { }
            return i > -1;
          };
      }

      // Get the closest matching element
      for (; elem && elem !== document; elem = elem.parentNode) {
        if (elem.matches(selector)) return elem;
      }
      return null;

    };

    function activateMenu() {
      var menuItems = document.getElementsByClassName("sub-menu-item");
      if (menuItems) {

        var matchingMenuItem = null;
        for (var idx = 0; idx < menuItems.length; idx++) {
          if (menuItems[idx].href === window.location.href) {
            matchingMenuItem = menuItems[idx];
          }
        }

        if (matchingMenuItem) {
          matchingMenuItem.classList.add('active');
          var immediateParent = getClosest(matchingMenuItem, 'li');
          if (immediateParent) {
            immediateParent.classList.add('active');
          }

          var parent = getClosest(matchingMenuItem, '.parent-menu-item');
          if (parent) {
            parent.classList.add('active');
            var parentMenuitem = parent.querySelector('.menu-item');
            if (parentMenuitem) {
              parentMenuitem.classList.add('active');
            }
            var parentOfParent = getClosest(parent, '.parent-parent-menu-item');
            if (parentOfParent) {
              parentOfParent.classList.add('active');
            }
          } else {
            var parentOfParent = getClosest(matchingMenuItem, '.parent-parent-menu-item');
            if (parentOfParent) {
              parentOfParent.classList.add('active');
            }
          }
        }
      }
    }

    // Clickable Menu
    if (document.getElementById("navigation")) {
      var elements = document.getElementById("navigation").getElementsByTagName("a");
      for (var i = 0, len = elements.length; i < len; i++) {
        elements[i].onclick = function (elem) {
          if (elem.target.getAttribute("href") === "javascript:void(0)") {
            var submenu = elem.target.nextElementSibling.nextElementSibling;
            submenu.classList.toggle('open');
          }
        }
      }
    }

    // Menu sticky
    function windowScroll() {
      const navbar = document.getElementById("topnav");
      if (navbar != null) {
        if (
          document.body.scrollTop >= 50 ||
          document.documentElement.scrollTop >= 50
        ) {
          // navbar.classList.add("nav-sticky");
        } else {
          // navbar.classList.remove("nav-sticky");
        }
      }
    }

    window.addEventListener('scroll', (ev) => {
      ev.preventDefault();
      windowScroll();
    })

    // back-to-top
    var mybutton = document.getElementById("back-to-top");
    window.onscroll = function () {
      scrollFunction();
    }

    function scrollFunction() {
      if (mybutton != null) {
        if (document.body.scrollTop > 500 || document.documentElement.scrollTop > 500) {
          mybutton.style.display = "block"
        } else {
          mybutton.style.display = "none"
        }
      }
    }

    $scope.topFunction = () => {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    }

  }

})  